import { render, staticRenderFns } from "./NormalSimpleBlackButton.vue?vue&type=template&id=9d8d5a58&scoped=true&"
import script from "./NormalSimpleBlackButton.vue?vue&type=script&lang=js&"
export * from "./NormalSimpleBlackButton.vue?vue&type=script&lang=js&"
import style0 from "./NormalSimpleBlackButton.vue?vue&type=style&index=0&id=9d8d5a58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d8d5a58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
